import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Close from '@mdi/svg/svg/close.svg';

import styles from 'src/components/Tile/TileActionsRemove.scss';


class TileActionsRemove extends PureComponent {
  render() {
    const { remove } = this.props;
    const title = 'Nie interesuje mnie ta oferta';
    return (
      <button
        className={ styles.delete }
        data-test="button-delete"
        onClick={ remove }
        title={ title }
        type="button"
      >
        <Close viewBox="0 0 24 24" />
      </button>
    );
  }
}

TileActionsRemove.propTypes = {
  remove: PropTypes.func.isRequired
};

export default TileActionsRemove;
